import PropTypes from 'prop-types';
import {
  ROUTE_TYPE_PUBLIC, ROUTE_TYPE_PRIVATE, ROUTE_TYPE_ANTI_PRIVATE, ROUTE_TYPE_CRUD,
} from './route-constants';

export const crudOptionsPropTypes = PropTypes.shape({
  index: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    tableType: PropTypes.oneOf(['filtered']), // TODO: Refactor string literal.
  }),
  detail: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['route', 'routeDialog', 'dialog']), // TODO: Refactor string literal.
  }),
  create: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
  }),
  edit: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
  }),
  delete: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
  }),
});

export const defaultCrudRouteOptionsPropTypes = {
  index: {
    enabled: true,
    tableType: 'filtered',
  },
  detail: {
    enabled: true,
    type: 'dialog',
  },
  create: {
    enabled: true,
  },
  edit: {
    enabled: true,
  },
  delete: {
    enabled: true,
  },
};

export const appRoutesPropTypes = PropTypes.shape({
  type: PropTypes.oneOf([
    ROUTE_TYPE_PUBLIC,
    ROUTE_TYPE_PRIVATE,
    ROUTE_TYPE_ANTI_PRIVATE,
    ROUTE_TYPE_CRUD,
  ]).isRequired,
  titleId: PropTypes.string,
  path: PropTypes.string,
  exact: PropTypes.bool,
  Component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ComponentDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  routes: PropTypes.any,
  crudOptions: crudOptionsPropTypes,
  componentProps: PropTypes.object,
  componentType: PropTypes.oneOf(['routeDialog', 'route']), // TODO: Refactor string literal.
});

export const flattenAppRoutesPropTypes = PropTypes.shape({
  type: PropTypes.oneOf([
    ROUTE_TYPE_PUBLIC,
    ROUTE_TYPE_PRIVATE,
    ROUTE_TYPE_ANTI_PRIVATE,
    ROUTE_TYPE_CRUD,
  ]).isRequired,
  titleId: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool.isRequired,
  Component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ComponentDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  componentProps: PropTypes.shape({
    routes: PropTypes.objectOf(appRoutesPropTypes),
    crudOptions: crudOptionsPropTypes,
  }),
});
